export { default as SafetechEncryption } from './safetech-encryption';
export type {
  IEncryptionConfig,
  IEncryptionError,
  IEncryptionResult,
  ISafetechEncryption,
} from './types';
